import template from './chargecode-create.html';
import controller from './chargecode-create.controller';

let chargecodeCreateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default chargecodeCreateComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecode-create/chargecode-create.component.js